module.exports = __webpack_public_path__ + "img/googG.37df4896.png";